module.exports = __webpack_public_path__ + "media/baojin.88179e67.mp3";